<template>
<div>
	<v-data-table
		:headers="headers"
		:items="scans"
		hide-actions
		class="elevation-1"
	>
		<template slot="items" slot-scope="props">
			<td>{{ props.item.document_number }}</td>
			<td class="text-xs-left">{{ currentScanType(props.item.type) }}</td>
			<td class="text-xs-left">{{ props.item.issued_at }}</td>
			<td class="text-xs-left">{{ props.item.invalid_at }}</td>
			<td class="text-xs-center">
				<v-tooltip slot="activator" top>
					<v-btn slot="activator" fab dark small color="indigo lighten-2"
						@click="setDataForm(props.item)"
					>
						<v-icon dark>edit</v-icon>
					</v-btn>
					<span>{{$t('common.edit')}}</span>
				</v-tooltip>
				<v-tooltip slot="activator" top>
					<a slot="activator" :href="getUrlScan(props.item.filename)" target="_blank">
						<v-btn fab dark small color="indigo lighten-2">
							<v-icon dark>cloud_download</v-icon>
						</v-btn>
					</a>
					<span>{{$t('common.download')}}</span>
				</v-tooltip>
				<ConfirmDialog v-bind="propConfirmDialog"
					@accept="onDelete(props.item.id)"
					:tooltip="$t('common.delete')"
				>
					<v-icon dark>delete</v-icon>
				</ConfirmDialog>
			</td>
		</template>
	</v-data-table>
	<v-layout row justify-end>
		<ScansForm
			:dialog="dialog"
			:dialogForm="dialogForm"
			@cancel="onClose"
			@save="onSave"
		/>
		<UploadFile
			:options="options"
			@progress-update="progressUpdate"
			@file-size-error="fileSizeError"
		/>
	</v-layout>
</div>
</template>

<script>
import   Vue from 'vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import DatePicker from '../../../../components/DatePicker'
import ImageView from '../../../../components/ImageView'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import ScansForm from '../scans/ScansForm'
import UploadFile from '../../../../components/UploadFile'
import { TEMPLATE_FORM_SCAN, HEADERS_TABLE_SCAN } from '../../../../constants'
import { notify } from '../../../../utils/notifications'
import { localeHeadersWorkers } from '../../../../utils/helpers'

export default {
	components: {
		DatePicker,
		ImageView,
		ConfirmDialog,
		ScansForm,
		UploadFile
	},
	data: vm => ({
		dialog: false,
		dialogForm: {
			...TEMPLATE_FORM_SCAN
		},
		headers: localeHeadersWorkers(HEADERS_TABLE_SCAN, vm.$t),
		propConfirmDialog: {
			message: vm.$t('workers.confirm_message_scan'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2'
			}
		},
		getImgProp: name => ({
			width: '50px',
			height: '50px',
			src: vm.getUrlScan(name),
			alt: 'scan image'
		}),
		options: {
			button: {
				slot: 'activator',
				fab: true,
				color: 'primary'
			},
			icon: 'add',
			className: 'btn-solid',
			tooltip: vm.$t('workers.upload_scan'),
			url: Vue.http.options.root + '/scans/worker/' + vm.$route.params.workerId
		},
		getUrlScan(name) {
			return Vue.http.options.root + '/files/' + name + '?show'
		}
	}),
	computed: {
		...mapState({
			scans: state => state.workers.workerDetail.scans
		}),
		...mapGetters({
			scanTypes: 'settings/scanTypes'
		})
	},
	methods: {
		...mapActions({
			getWorkers: 'workers/fetchOne',
			deleteScan: 'workers/deleteScan',
			updateScan: 'workers/updateScan'
		}),
		setDataForm(dialogForm) {
			this.dialogForm = { ...dialogForm }
			this.dialog = true
		},
		onClose: function() {
			this.dialog = false
			this.dialogForm = { ...TEMPLATE_FORM_SCAN }
		},
		onSave: function() {
			const data = { ...this.dialogForm }
			this.updateScan(data).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.updated', { type: this.$t('workers.scan') })
				})
			})
			this.dialog = false
			this.dialogForm = { ...TEMPLATE_FORM_SCAN }
		},
		onDelete(id) {
			this.deleteScan(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', { type: this.$t('workers.scan') })
				})
			})
		},
		fileSizeError: () => console.log('SIZE ERROR'),
		progressUpdate: async function(listFiles) {
			if (listFiles[0].type === 'success') {
				this.$notify({
					...notify,
					text: this.$t('notifications.upload', { type: this.$t('workers.scan') })
				})
				const response = JSON.parse(listFiles[0].response)
				const { id } = response
				const { body } = await this.getWorkers()
				const editebleItem = body.scans.find(scan => scan.id === id)
				this.setDataForm(editebleItem)
			}
		},
		currentScanType (key) {
			return this.scanTypes.find(scanType => scanType.key === key)
				? this.scanTypes.find(scanType => scanType.key === key).value
				: ''
		}
	}
}
</script>
